import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import React from 'react'
import { Card } from 'react-bootstrap'
import { FormattedNumber } from 'react-intl'

function StatCard(props) {
  const needsPrefix = props.value < 0 || !!props.prefix
  const prefix = needsPrefix && (
    <sup>
      {props.positive ? <FontAwesomeIcon icon={['far', 'plus']} /> : null}
      {props.value < 0 ? <FontAwesomeIcon icon={['far', 'minus']} /> : null}
      {props.prefix ? <FontAwesomeIcon icon={props.prefix} fixedWidth /> : null}
    </sup>
  )
  const unit = !!props.unit && <sup>{props.unit}</sup>

  const loss = props.value < 0
  let value = Math.abs(props.value)
  if (props.integer) {
    value = Math.round(value)
  }

  return (
    <Card className="stat-card shadow h-100">
      <Card.Body className="d-flex flex-column justify-content-between">
        <Card.Title className="text-uppercase">{props.title}</Card.Title>
        <div className={`value text-center ${loss ? 'text-danger' : ''}`}>
          {prefix}
          <FormattedNumber
            value={value}
            minimumFractionDigits={props.integer ? 0 : 2}
          />
          {unit}
        </div>
      </Card.Body>
    </Card>
  )
}

StatCard.propTypes = {
  integer: PropTypes.bool,
  prefix: PropTypes.node,
  positive: PropTypes.bool,
  title: PropTypes.string.isRequired,
  unit: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
}

export default StatCard
